import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import webSocketMiddleware from './middlewares/webSocketMiddleware';

import rootReducer from '#app/reducers';
import rootSaga from './sagas';

export default (initialState = {}, queryClient = null) => {
  const sagaMiddleware = createSagaMiddleware();

  const composedEnhancers = compose(
    applyMiddleware(sagaMiddleware, webSocketMiddleware(queryClient))
  );

  const store = createStore(rootReducer, initialState, composedEnhancers);

  sagaMiddleware.setContext({
    queryClient,
  });

  sagaMiddleware.run(rootSaga);

  // if (process.env.NODE_ENV !== 'production') {
  //   if (module.hot) {
  //     module.hot.accept('./reducers', () => {
  //       store.replaceReducer(rootReducer)
  //     })
  //   }
  // }

  return store;
};
